:host {
  display: block;
}

.button {
  outline: none;
  background-color: transparent;
  border-style: solid;
  border-width: 2px;
  border-color: var(--color-button-tertiary);
  padding-left: var(--spacing-05);
  padding-right: var(--spacing-10);
  height: calc(var(--spacing-08) + 0.25rem);
  cursor: pointer;
}
.button.sm {
  height: calc(var(--spacing-07) + 0.25rem);
}
.button.lg {
  height: calc(var(--spacing-09) + 0.25rem);
}
.button.xl {
  height: calc(var(--spacing-10) + 0.25rem);
}
.button.xxl {
  height: calc(var(--spacing-11) + 0.25rem);
}
.button .label {
  color: var(--color-button-tertiary);
  font-size: var(--type-scale-16);
}
.button:hover {
  background-color: var(--color-button-tertiary-hover);
}
.button:hover .label {
  color: var(--color-text-inverse);
}
.button:active {
  background-color: var(--color-button-tertiary-active);
}
.button:active .label {
  color: var(--color-text-inverse);
}
.button:focus {
  background-color: var(--color-button-tertiary-hover);
  border-color: var(--color-focus);
  box-shadow: inset 0 0 0 1px var(--color-focus-inset), inset 0 0 0 2px var(--color-focus);
}
.button:focus .label {
  color: var(--color-text-inverse);
}
.button:disabled {
  background-color: transparent;
  border-color: var(--color-button-disabled);
}
.button:disabled .label {
  color: var(--color-text-disabled);
}


.button.primary {
  background-color: var(--color-button-primary);
  border-color: var(--color-button-primary);
}
.button.primary .label {
  color: var(--color-text-interactive);
}
.button.primary:hover {
  background-color: var(--color-button-primary-hover);
}
.button.primary:active {
  background-color: var(--color-button-primary-active);
}
.button.primary:focus {}
.button.primary:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
}
.button.primary:disabled .label {
  color: var(--color-text-interactive-disabled);
}

.button.secondary {
  background-color: var(--color-button-secondary);
  border-color: var(--color-button-secondary);
}
.button.secondary .label {
  color: var(--color-text-interactive);
}
.button.secondary:hover {
  background-color: var(--color-button-secondary-hover);
}
.button.secondary:active {
  background-color: var(--color-button-secondary-active);
}
.button.secondary:focus {}
.button.secondary:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
}
.button.secondary:disabled .label {
  color: var(--color-text-interactive-disabled);
}

.button.danger {
  background-color: var(--color-button-danger);
  border-color: var(--color-button-danger);
}
.button.danger .label {
  color: var(--color-text-interactive);
}
.button.danger:hover {
  background-color: var(--color-button-danger-hover);
}
.button.danger:active {
  background-color: var(--color-button-danger-active);
}
.button.danger:focus {}
.button.danger:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
}
.button.danger:disabled .label {
  color: var(--color-text-interactive-disabled);
}

.button.ghost {
  background-color: transparent;
  border-color: transparent;
}
.button.ghost .label {
  color: var(--color-link-primary);
}
.button.ghost:hover {
  background-color: var(--color-background-hover);
}
.button.ghost:active {
  background-color: var(--color-background-active);
}
.button.ghost:focus {}
.button.ghost:disabled {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
}
.button.ghost:disabled .label {
  color: var(--color-text-interactive-disabled);
}
